export const rotationCriteriaOptionalFields = {
  developer: {
    key: 1,
    value: "developer",
    translationKey: "developer-label",
    isActive: false,
  },
  unitType: {
    key: 2,
    value: "unitType",
    translationKey: "unit-type-label",
    isActive: false,
  },
  priceRange: {
    key: 3,
    value: "priceRange",
    translationKey: "price-range-label",
    isActive: false,
  },
  size: {
    key: 4,
    value: "size",
    translationKey: "size-label",
    isActive: false,
  },
  bedrooms: {
    key: 5,
    value: "bedrooms",
    translationKey: "bedroom-label",
    isActive: false,
  },
  mediaDetails: {
    key: 6,
    value: "mediaDetails",
    translationKey: "media-detail-label",
    isActive: false,
  },
  leadCampaign: {
    key: 7,
    value: "leadCampaign",
    translationKey: "lead-campaign-label",
    isActive: false,
  },
  methodOfContact: {
    key: 8,
    value: "methodOfContact",
    translationKey: "method-of-contacts-label",
    isActive: false,
  },
  preferredLanguage: {
    key: 9,
    value: "preferredLanguage",
    translationKey: "lead-preferred-language-label",
    isActive: false,
  },
  location: {
    key: 10,
    value: "location",
    translationKey: "specific-location-label",
    isActive: false,
  },
    bathrooms: {
    key: 11,
    value: "bathrooms",
    translationKey: "bathroom-label",
    isActive: false,
  },
};
